// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

export const isRelease = window.location.href.includes('zkid.app');

export const endpoint = isRelease
  ? 'https://zkpverify-service.zkid.app'
  : 'https://zkpverify-service.starks.network';
